import QCarouselItem from '../carousel/src/item';



export default QCarouselItem;
